var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',[_c('header-page',{attrs:{"title":"Insight"}}),_vm._v(" "),_c('analytic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }